import React, { useState } from 'react'
import './contact.css'
import AppNavbar from '../../components/Navbar';
import { Card , Container , Col , Row , Form , Button} from 'react-bootstrap'
import callcalling from '../../images/callcalling.png'
import call from '../../images/call.png'
import directinbox from '../../images/direct-inbox.png'
import location from '../../images/location.png'
import rectangle20 from '../../images/Rectangle 20.png'
import {useNavigate } from 'react-router-dom';

const Contact = () => {
  const navigate = useNavigate()
  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false)
    } else{

    setValidated(true);
    navigate('/')}
  };
  return (
    <div>
        <AppNavbar/>
        <Card className="border-none text-white"style={{borderRadius:'none'}}>
      <Card.Img src={rectangle20} alt="Card image" style={{ width: '100%',maxHeight:'650px', minHeight:'400px'}}/>
      <Card.ImgOverlay style={{}} className='contact-cover align-items-center justify-content-center text-center text-align-center py-md-5 py-2'>
      <div className='my-5 py-5 px-2' style={{background:'none', borderRadius:'none'}}>
        
          
        <Card.Title className='contact-title mb-4 mt-lg-5' >Contact Us</Card.Title>
        
        <Card.Text className='sub-contact-title mx-md-5 px-lg-5'>
        Get in touch with us today and let us help with all your needs. Our team is ready to assist you 24/7
        </Card.Text>
      
</div>
      </Card.ImgOverlay>
    </Card>

       
    <Container fluid className='px-lg-5 px-3 py-5 mt-md-3'>
    
        <Row className="gap-5 gap-lg-5 gap-md-2 mx-lg-5">
          <Col md={5} lg={4} className="contact-list">
          
              <div style={{backgroundColor: "#f9f9f9"}} className=' mb-4 d-flex align-items-center gap-4 p-2'>
                
                  <img src={call} alt="call" style={{backgroundColor: "white", borderRadius: '50%', padding:'10px'}} />
                
                
                  <div className="float-div">
                    <h5 className="float-heading mt-2">Phone Number</h5>
                    <p>+23481 0819 4392</p>
                  </div>
                
              </div>
           
          
              <div style={{backgroundColor: "#f9f9f9"}} className=' mb-4 d-flex align-items-center gap-4 p-2'>
                
                  <img src={directinbox} alt="inbox" style={{backgroundColor: "white", borderRadius: '50%', padding:'10px'}} />
                
                
                  <div className="float-div">
                    <h5 className="float-heading mt-2">Email Address</h5>
                    <p>tripz@gmail.com</p>
                  </div>
                
              </div>
            
          
              <div style={{backgroundColor: "#f9f9f9"}} className=' mb-4 d-flex align-items-center gap-4 p-2'>
                
                  <img src={callcalling} alt="dialimage"  style={{backgroundColor: "white", borderRadius: '50%', padding:'10px'}}/>
                
                
                  <div className="float-div">
                    <h5 className="float-heading">Fax Address</h5>
                    <p>0032 43562 1142</p>
                  </div>
                
              </div>
           
          
              <div style={{backgroundColor: "#f9f9f9"}} className=' mb-4 d-flex align-items-center gap-4 p-2'>
                
                  <img src={location} alt="location" style={{backgroundColor: "white", borderRadius: '50%', padding:'10px'}} />
                
                
                  <div className="float-div">
                    <h5 className="float-heading mt-2">Head Office</h5>
                    <p>34, Faith avenue, Lagos</p>
                  </div>
                
              </div>
           
          </Col>
          
          
          <Col md={true} className="p-4" style={{backgroundColor: "#f9f9f9"}}>
            <Form id="access-form" className="contact-form"  noValidate validated={validated} onSubmit={handleSubmit}>
              <h3 className='mb-3'>Send Message</h3>
              <p>Send us an instant message now, we value every feedback and our experts are waiting to respond</p>
              <Row className="form-gap">
                <Col className="mb-4" lg={6}>
                <Form.Group controlId="validationCustom01">
                  <Form.Control type="text" placeholder="Your Name" name="fullName" required />
                  <Form.Control.Feedback type="invalid">Please fill your name</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col className="mb-4" lg={6}>
                <Form.Group controlId="validationCustom02">
                  <Form.Control type="email" placeholder="Email address" name="email" required/>
                  <Form.Control.Feedback type="invalid">Please fill your email address</Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="form-gap">
                <Col className="mb-4" lg={6}>
                <Form.Group controlId="validationCustom03">
                  <Form.Control type="text" placeholder="Phone number" required/>
                  <Form.Control.Feedback type="invalid">Please fill your phone number</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col className="mb-4" lg={6}>
                  <Form.Control type="text" placeholder="Subject" />
                  
                </Col>
              </Row>
              
              <Form.Group className="mb-4"  controlId="validationCustom04">
            
                <Form.Control as="textarea" rows={5} placeholder="Message" required/>
                <Form.Control.Feedback type="invalid">Please drop your message</Form.Control.Feedback>
               
              </Form.Group>
              <div className="">
                <Button className="signup-btn" type="submit" style={{height: '40px',
    width: '200px',
    
    borderRadius: '8px',
    
    backgroundColor: '#008080'}}>
                  Send Message
                </Button>
              </div>
            </Form>
          </Col>
          
        </Row>
        
      </Container>






    </div>
  )
}

export default Contact


